import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper } from '../../../utils/tools';
import { formValues } from './validationSchema';

import { Form, Row, Col, Button } from 'react-bootstrap';

import { editWarehouse, fetchWarehouses, checkWarehouseExists } from '../../../store/actions/warehouse';

const EditWarehouse = ({ warehouse, onClose }) => {
    const notifications = useSelector(state => state.notifications);
    const currentBranch = useSelector(state => state.branch.current);
    const [isChecking, setIsChecking] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { ...formValues, warehouse: warehouse, newWarehouse: '' },
        validationSchema: Yup.object({
            warehouse: Yup.string()
                .required('Názov skladu je povinný')
                .min(3, 'Názov skladu musí mať minimálne 3 znaky')
                .max(16, 'Názov skladu môže mať maximálne 16 znakov'),
            newWarehouse: Yup.string()
                .required('Nový názov skladu je povinný')
                .min(3, 'Názov skladu musí mať minimálne 3 znaky')
                .max(16, 'Názov skladu môže mať maximálne 16 znakov')
                .test('checkDuplicateWarehouse', 'Sklad s týmto názvom už existuje', async (value) => {
                    if (!value) return true;
                    setIsChecking(true);
                    try {
                        const result = await dispatch(checkWarehouseExists({ branchId: currentBranch, warehouse: value }));
                        const exists = result.payload;
                        return !exists; // Ak exists je true, vráti false, čo spôsobí chybu
                    } catch (error) {
                        console.error('Error checking warehouse:', error);
                        return false;
                    } finally {
                        setIsChecking(false);
                    }
                })
        }),
        onSubmit: async (values) => {
            await handleSubmit(values);
        },
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: true
    });

    // Reset form on success notification
    useEffect(() => {
        if (notifications && notifications.global.success) {
            formik.resetForm();
        }
    }, [notifications, formik]);

    const handleSubmit = async (values) => {
        if (currentBranch) {
            values.branchId = currentBranch;

            // Odošlite údaje s oboma hodnotami, warehouse a newWarehouse
            await dispatch(editWarehouse(values));

            if (currentBranch) {
                await dispatch(fetchWarehouses(currentBranch));
            }

            // Close modal
            onClose();
        }
    };

    useEffect(() => {
        formik.setValues({
            warehouse: warehouse,
            newWarehouse: ''
        });
    }, [warehouse]);

    return (
        <Form
            component="form"
            onSubmit={formik.handleSubmit}
        >
            <h2>Upraviť sklad</h2>
            <hr />

            <Row>
                {/* Current Warehouse */}
                <Form.Group className="mb-3" controlId="formBasicWarehouse">
                    <Form.Label>Pôvodný názov skladu</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Sklad:"
                        value={formik.values.warehouse}
                        readOnly
                        disabled={true}
                    />
                </Form.Group>

                {/* New Warehouse */}
                <Form.Group className="mb-3" controlId="formBasicNewWarehouse">
                    <Form.Label>Nový názov skladu</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Nový názov skladu:"
                        {...formik.getFieldProps('newWarehouse')}
                        isInvalid={formik.touched.newWarehouse && formik.errors.newWarehouse}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errorHelper(formik, 'newWarehouse').helperText}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row className="mt-3">
                <hr />
                <Col className="d-flex justify-content-end">
                    <Button
                        className='button-custom-large'
                        variant='primary'
                        type="submit"
                    >
                        Upraviť sklad
                    </Button>
                </Col>
            </Row>

        </Form>
    );
};

export default EditWarehouse;
